import { Schedule } from "@mui/icons-material";
import { Box, Container, Paper, Typography } from "@mui/material";
import React from "react";
import TALogo from "../logo/TALogo.svg";

interface MaintenancePageProps {
  estimatedEnd?: string;
  message?: string;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({
  estimatedEnd,
  message = "We're currently performing scheduled maintenance to improve your experience.",
}) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        padding: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={1}
          sx={{
            padding: 4,
            textAlign: "center",
            borderRadius: 2,
          }}
        >
          {/* <Construction
            sx={{
              fontSize: 80,
              color: "#005292",
              marginBottom: 2,
            }}
          /> */}
          <Box
            component={"img"}
            src={TALogo}
            alt="Logo"
            sx={{ width: "200px" }}
          />

          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              color: "#005292",
              fontWeight: 600,
              marginBottom: 2,
            }}
          >
            Under Maintenance
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            paragraph
            sx={{ marginBottom: 3 }}
          >
            {message}
          </Typography>

          {estimatedEnd && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                marginBottom: 3,
              }}
            >
              <Schedule color="action" />
              <Typography variant="body1" color="text.secondary">
                Expected completion: {estimatedEnd}
              </Typography>
            </Box>
          )}

          <Typography variant="body2" color="text.secondary">
            We apologise for any inconvenience. Please check back shortly.
          </Typography>

          {/* <Box sx={{ marginTop: 3 }}>
            <Typography variant="body2" color="text.secondary">
              For urgent matters, please contact support at{" "}
              <a
                href="mailto:support@teacheractive.com"
                style={{ color: "#005292", textDecoration: "none" }}
              >
                support@teacheractive.com
              </a>
            </Typography>
          </Box> */}
        </Paper>
      </Container>
    </Box>
  );
};

export default MaintenancePage;
